// @flow

import React from 'react'
import ReputationListItem, {
  type PropTypes as ReputationListItemProps,
} from 'components/molecules/ReputationListItem'
import ReputationListHeader from 'components/organisms/ReputationListHeader'
import Path from 'routes/path'

export type PropTypes = {
  spaceUsername: string,
  roomUid: string,
  score: number,
  count: number,
  owner: Object,
  reputations: Array<ReputationListItemProps>,
}

export default (props: Object) => (
  <section className="space-main__section-big">
    <h2 className="space-main__headline-big">{i18n.t('page.room.review')}</h2>
    <ReputationListHeader
      count={props.count}
      score={props.score}
      linkUrl={Path.roomReputationList(props.spaceUsername, props.roomUid)}
    />
    <div className="mod-review__box">
      {props.reputations.map((reputation, i: number) => (
        <ReputationListItem
          key={`reputation_list_item_${i}`}
          owner={props.owner}
          reputation={reputation}
        />
      ))}
    </div>
    <p className="ta-r">
      <a href={Path.roomReputationList(props.spaceUsername, props.roomUid)}>
        {i18n.t('page.shared.review.more')}
        <i className="fa fa-angle-right ml10" />
      </a>
    </p>
  </section>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailReviewSection/index.jsx